<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    position="center"
    :height="100"
    :padding="0"
    :closeable="false"
    :close-on-click-overlay="false"
    :overlay-style="overlayStyle"
    @close="handlePopupClosed"
  >
    <template #content>
      <div class="security-certification-popup">
        <div class="security-certification-popup__scroll">
          <div class="security-certification-popup__content">
            <div class="security-certification-popup__banner">
              <img class="security-certification-popup__image" :src="bannerUrl" alt="Plataforma segura" />
              <button
                type="button"
                class="security-certification-popup__action"
                aria-label="Começar com segurança"
                @click="handleClose"
              ></button>
            </div>

            <CheckboxPublic type="security-certification" />

            <button type="button" class="security-certification-popup__close chxy-row-c-c" aria-label="Fechar" @click="handleClose">
              <van-icon name="close" size="32" color="#FFFFFF" />
            </button>
          </div>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const STORAGE_KEY = 'SecurityCertificationPopupChecked'

const route = useRoute()
const PopupRef = ref(null)
const isOpen = ref(false)

const bannerUrl = getImageUrlWithCDN_LOCAL('/home2/security_certification_banner.avif')
const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.58)',
  backdropFilter: 'blur(7px)',
  WebkitBackdropFilter: 'blur(7px)',
}

const open = () => {
  if (window.localStorage.getItem(STORAGE_KEY) === 'checked') return false
  // 队列可能被登录状态与登录弹窗关闭事件同时触发；已展示时视为成功，避免后续弹窗穿透
  if (isOpen.value) return true
  if (route.name !== 'Home') return false

  isOpen.value = true
  nextTick(() => {
    PopupRef.value?.open()
  })
  return true
}

const handleClose = () => {
  PopupRef.value?.close()
}

const handlePopupClosed = () => {
  isOpen.value = false
  emit('close')
}

const emit = defineEmits(['close'])

defineExpose({ open })
</script>

<style lang="less" scoped>
.security-certification-popup {
  width: 100%;
  height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  pointer-events: none;

  &__scroll {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: max(20px, env(safe-area-inset-top)) 0 max(24px, env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  &__content {
    width: min(396px, calc(100vw - 64px));
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: auto;
  }

  &__banner {
    position: relative;
    width: 100%;
    max-height: calc(100dvh - 148px);
    aspect-ratio: 2 / 3;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__action {
    position: absolute;
    left: 4%;
    right: 4%;
    top: 79.5%;
    height: 8.5%;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background: transparent;
    cursor: pointer;
  }

  &__close {
    width: 44px;
    height: 44px;
    margin-top: 14px;
    padding: 0;
    border-radius: 50%;
    cursor: pointer;
  }

  :deep(.checkbox-view) {
    margin-top: 10px;
  }

  :deep(.checkbox-container) {
    min-height: 34px;
    padding: 5px 12px;
    background: rgba(0, 0, 0, 0.42);
  }
}
</style>
